import { useContext } from 'react';
import GuestyPayContext from "../contexts/guestyPayContext";
var useGuestyPay = function useGuestyPay() {
  return useContext(GuestyPayContext);
};
export default useGuestyPay;